import { BaseHelpPopup } from './__internal__/';
import { jsx as _jsx } from "react/jsx-runtime";
export const HelpPopup = props => /*#__PURE__*/_jsx(BaseHelpPopup, {
  ...props
});
//# sourceMappingURL=HelpPopup.js.map